import type { Opening } from './mock/data'

export function cloneTemplate(root: ParentNode, name: string): HTMLElement {
  const template = root.querySelector<HTMLTemplateElement>(`template[data-preview-template="${name}"]`)!
  return template.content.firstElementChild!.cloneNode(true) as HTMLElement
}

export function text(root: ParentNode, field: string, value: string): void {
  root.querySelector<HTMLElement>(`[data-preview-field="${field}"]`)!.textContent = value
}

export function setCompanyLogo(root: ParentNode, target: HTMLElement, company: string): void {
  const template = root.querySelector<HTMLTemplateElement>(`template[data-preview-company="${CSS.escape(company)}"]`)
  if (template) target.replaceChildren(template.content.cloneNode(true))
  else target.textContent = company.charAt(0)
}

export function fillOpening(root: ParentNode, row: HTMLElement, opening: Opening): void {
  row.dataset.opening = opening.id
  for (const field of ['company', 'title', 'location', 'pay'] as const) {
    row.querySelectorAll<HTMLElement>(`[data-preview-field="${field}"]`).forEach((element) => {
      element.textContent = opening[field]
    })
  }
  const logo = row.querySelector<HTMLElement>('[data-preview-logo]')
  if (logo) setCompanyLogo(root, logo, opening.company)
  const tags = row.querySelector('[data-preview-tags]')
  if (tags) {
    tags.replaceChildren(
      ...opening.tags.map((tag) => {
        const chip = cloneTemplate(root, 'tag')
        chip.textContent = tag
        return chip
      })
    )
  }
}
